var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.author)?_c('author-detail',{attrs:{"author":_vm.author,"memorials":_vm.memorials,"level":_vm.$route.params.level,"current-level":_vm.currentLevel,"current-memorial":_vm.currentMemorial}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }